import React from 'react';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import { string, func, bool } from 'prop-types';
import {
  generalErrorImage,
  EmptyRoomAvailabilityImage,
} from '../../utils/statics';
import { EMPTY_STATE } from '../../utils/constants';
import EmptyState from './EmptyState';

const EmptyStateProvider = ({
  type,
  action,
  isMobileView,
  theme,
  move,
  enableErrorRevamp,
}) => {
  const descriptionProps = { style: { maxWidth: 205 } };
  switch (type) {
    case EMPTY_STATE.EMPTY_HOTEL_LIST:
      return (
        <EmptyState
          image={generalErrorImage}
          title={
            enableErrorRevamp
              ? translate('statusCode.hotelNotFound.title')
              : translate('hotelCard.noHotelFound.title')
          }
          description={
            enableErrorRevamp
              ? translate('statusCode.hotelNotFound.body')
              : translate('hotelCard.noHotelFound.description')
          }
          buttonTitle={translate('hotelCard.noHotelFound.buttonTitle')}
          onButtonClick={action}
          theme={theme}
          move={move}
        />
      );
    case EMPTY_STATE.EMPTY_FLIGHT_HOTEL_SNAP:
      return (
        <EmptyState
          image={generalErrorImage}
          title={
            enableErrorRevamp
              ? translate('statusCode.flightsNotFound.title')
              : translate('snap.noFlightHotel.title')
          }
          description={
            enableErrorRevamp
              ? translate('statusCode.flightsNotFound.body')
              : translate('snap.noFlightHotel.description')
          }
          descriptionProps={descriptionProps}
          buttonTitle={translate('snap.noFlightHotel.buttonTitle')}
          onButtonClick={action}
          theme={theme}
          move={move}
        />
      );

    case EMPTY_STATE.EMPTY_HOTEL_ROOM_LIST:
      return (
        <EmptyState
          image={EmptyRoomAvailabilityImage}
          title={
            enableErrorRevamp
              ? ''
              : translate('hotel.roomSelect.thereAreNoRooms')
          }
          description={
            enableErrorRevamp
              ? translate('statusCode.roomDetailsNotFound')
              : translate('hotel.roomSelect.letSearchForRooms')
          }
          isMobileView={isMobileView}
          theme={theme}
          move={move}
        />
      );

    case EMPTY_STATE.EMPTY_BROWSER_HISTORY:
      return (
        <EmptyState
          image={generalErrorImage}
          title={translate('error.title')}
          description={translate('error.description')}
          buttonTitle={translate('badRequest.goHomeTitle')}
          onButtonClick={action}
          theme={theme}
          move={move}
        />
      );

    case EMPTY_STATE.EMPTY_HOTEL_LIST_ON_FILTER:
      return (
        <EmptyState
          image={generalErrorImage}
          title={
            enableErrorRevamp
              ? translate('statusCode.hotelNotFound.title')
              : translate('locationFilter.noHotels.title')
          }
          description={
            enableErrorRevamp
              ? translate('statusCode.hotelNotFound.body')
              : translate('locationFilter.noHotels.description')
          }
          buttonTitle={translate('locationFilter.noHotels.buttonTitle')}
          onButtonClick={action}
          theme={theme}
          move={move}
        />
      );

    default:
      return (
        <EmptyState
          image={generalErrorImage}
          title={translate('error.title')}
          description={translate('error.description')}
          buttonTitle={translate('error.buttonTitle')}
          onButtonClick={action}
          theme={theme}
          move={move}
        />
      );
  }
};

EmptyStateProvider.propTypes = {
  type: string,
  action: func,
  isMobileView: bool,
  theme: string,
  move: bool,
  enableErrorRevamp: bool,
};

export default EmptyStateProvider;
